/* eslint-disable react-hooks/exhaustive-deps */
import DataTableGrid from '../../../shared/formUtilities/useTable';
import { ReportsService } from '../reportsService';
import { useState } from 'react';
import { InitializeColumnsUserSurvey } from '../reportsColumn';
import { useEffect } from 'react';
import { SurveyUserDetailDialog } from './surveyUserDetailDialog';

function groupByQuarterAndRating(data) {
  const groupedData = {};

  data.forEach((item) => {
    const date = new Date(item.createDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;

    // Determine the quarter
    let quarter;
    if (month >= 1 && month <= 3) {
      quarter = "Q1";
    } else if (month >= 4 && month <= 6) {
      quarter = "Q2";
    } else if (month >= 7 && month <= 9) {
      quarter = "Q3";
    } else if (month >= 10 && month <= 12) {
      quarter = "Q4";
    }

    const quarterKey = `${year}-${quarter}`;

    // Initialize quarter group if it doesn't exist
    if (!groupedData[quarterKey]) {
      groupedData[quarterKey] = [];
    }

    // Find or create the rating array within the quarter group
    let ratingGroup = groupedData[quarterKey].find(
      (group) => group.rating === item.rating
    );

    if (!ratingGroup) {
      ratingGroup = { rating: item.rating, items: [] };
      groupedData[quarterKey].push(ratingGroup);
    }

    // Add the item to the appropriate rating array
    ratingGroup.items.push(item);
  });

  // Convert each quarter's data to an array of items grouped by rating
  return Object.entries(groupedData).map(([quarterKey, groups]) => ({
    quarter: quarterKey,
    ratings: groups.map((group) => ({
      rating: group.rating,
      items: group.items
    }))
  }));
}


export const UserSurvey = () => {
  const reportsService = new ReportsService();
  const [surveyList, setSurveyList] = useState([]);
  const [loading, setloading] = useState(false);
  const [showUserInfo, setShowUserInfo] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const [serveyDetail, setServeyDetail] = useState({ row: null, currentPoint: null });
  const columns = InitializeColumnsUserSurvey({
    onSurveyPointClick: (row, currentPoint) => {
      setServeyDetail({ row: row?.original, currentPoint: currentPoint });
    }
  });

  useEffect(() => {
    getAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    queryParameters.get('currentPage'),
    queryParameters.get('perPage'),
    window.location.search,
  ]);

  useEffect(() => {
    if (serveyDetail?.row) {
      setShowUserInfo(true);
    } else {
      setShowUserInfo(false);
    }
  }, [serveyDetail]);

  const getAll = () => {
    setloading(true);
    // let currentPage = queryParameters.get('currentPage')
    //   ? parseInt(queryParameters.get('currentPage'))
    //   : 1;
    // let perPage = queryParameters.get('perPage')
    //   ? parseInt(queryParameters.get('perPage'))
    //   : 10;
    // let filter = FilterHelper.mapFilters(queryParameters);
    reportsService
      .getUserSurveyList(1, 9999)
      .then((resp) => {
        setloading(false);
        setSurveyList(groupByQuarterAndRating(resp?.data?.items)?.reverse());
      })
      .catch((err) => {
        setloading(false);
      });
  };

  // function onNavigate(currentPage, perPage, filterObj = filter) {
  //   let filterParams = filterObj ? FilterHelper.mapToParams(filterObj) : '';
  //   navigate({
  //     pathname: buildRegionizeRoute(
  //       `${AppRoutes.Reports}/${AppRoutes.ReportUserSurvey}`
  //     ),
  //     search: `?currentPage=${currentPage}&perPage=${perPage}${filterParams}`,
  //   });
  // }

  // const onPageSizeChange = (e) => {
  //   onNavigate(1, e);
  // };

  // const onPageChange = (e) => {
  //   onNavigate(e + 1, pagination.perPage);
  // };

  // const onDownloadCSV = () => {
  //   setloading(true);
  //   reportsService
  //     .exportInvestorShareholders()
  //     .then((resp) => {
  //       const date = DateHelper.formatDate(new Date());
  //       const fileName = `Investor-Shareholders-${date}.csv`;
  //       saveAs(resp.data, fileName);
  //       setloading(false);
  //     })
  //     .catch((err) => {
  //       setloading(false);
  //     });
  // };

  return (
    <>
      <DataTableGrid
        columnPinningLeft={['quarter']}
        hideSerialNumbers
        showDownloadCSV={false}
        // download={() => {
        //   onDownloadCSV();
        // }}
        name={'surveyTbl'}
        // pagination={pagination}
        // onPageChange={onPageChange}
        // onPageSizeChange={onPageSizeChange}
        columns={columns}
        heading={'User Survey'}
        records={surveyList}
        isPagination={false}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
      {showUserInfo ? <SurveyUserDetailDialog detail={serveyDetail} onClose={(e) => {
        setServeyDetail({ row: null, currentPoint: null });
      }} state={showUserInfo} /> : null}
    </>
  );
};
